import script from "./ComicListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComicListView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__